// REST + WebSocket 客户端
const TOKEN_KEY = "ai-town-token";

// localStorage 在隐私模式/部分运行时可能不可用,统一容错
export function getToken() { try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; } }
export function setToken(t: string) { try { localStorage.setItem(TOKEN_KEY, t); } catch { /* 忽略 */ } }
export function clearToken() { try { localStorage.removeItem(TOKEN_KEY); } catch { /* 忽略 */ } }

async function req(path: string, opts: RequestInit = {}) {
  const res = await fetch(path, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      ...(opts.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `请求失败(${res.status})`);
  return data;
}

export const api = {
  register: (email: string, username: string, password: string) =>
    req("/api/register", { method: "POST", body: JSON.stringify({ email, username, password }) }),
  login: (account: string, password: string) =>
    req("/api/login", { method: "POST", body: JSON.stringify({ account, password }) }),
  verifyEmail: (email: string, code: string) =>
    req("/api/verify-email", { method: "POST", body: JSON.stringify({ email, code }) }),
  resendVerify: (email: string) =>
    req("/api/resend-verify", { method: "POST", body: JSON.stringify({ email }) }),
  forgotPassword: (email: string) =>
    req("/api/forgot-password", { method: "POST", body: JSON.stringify({ email }) }),
  resetPassword: (email: string, code: string, password: string) =>
    req("/api/reset-password", { method: "POST", body: JSON.stringify({ email, code, password }) }),
  me: () => req("/api/me"),
  createAgent: (data: any) => req("/api/agent/create", { method: "POST", body: JSON.stringify(data) }),
  feed: (before?: number) => req(`/api/feed${before ? `?before=${before}` : ""}`),
  profile: (id: string) => req(`/api/agents/${id}`),
  memories: (agentId: string, offset: number, limit: number) => req(`/api/agents/${agentId}/memories?offset=${offset}&limit=${limit}`),
  chatHistory: (agentId: string) => req(`/api/chat/${agentId}`),
  chat: (agentId: string, text: string) => req("/api/chat", { method: "POST", body: JSON.stringify({ agentId, text }) }),
  setGoals: (data: any) => req("/api/agent/goals", { method: "POST", body: JSON.stringify(data) }),
  guestJoin: (name?: string) => req("/api/guest/join", { method: "POST", body: JSON.stringify({ name: name || "" }) }),
  board: () => req("/api/board"),
  postBoard: (content: string) => req("/api/board", { method: "POST", body: JSON.stringify({ content }) }),
  webmcpState: () => req("/api/webmcp/state"),
  webmcpMove: (x: number, y: number) => req("/api/webmcp/move", { method: "POST", body: JSON.stringify({ x, y }) }),
  webmcpSay: (text: string) => req("/api/webmcp/say", { method: "POST", body: JSON.stringify({ text }) }),
  usage: (hours = 24) => req(`/api/stats/usage?hours=${hours}`),
  status: () => req("/api/status"),
};

// ---------- WebSocket ----------
type WSHandler = (msg: any) => void;

export class TownSocket {
  private ws: WebSocket | null = null;
  private handlers = new Set<WSHandler>();
  private retry = 0;
  private closed = false;

  connect() {
    const proto = location.protocol === "https:" ? "wss" : "ws";
    const ws = new WebSocket(`${proto}://${location.host}/ws`);
    this.ws = ws;
    ws.onopen = () => {
      this.retry = 0;
      ws.send(JSON.stringify({ type: "auth", token: getToken() }));
    };
    ws.onmessage = (e) => {
      let msg: any;
      try { msg = JSON.parse(e.data); } catch { return; }
      for (const h of this.handlers) h(msg);
    };
    ws.onclose = () => {
      if (this.closed) return;
      this.retry++;
      setTimeout(() => this.connect(), Math.min(1000 * this.retry, 8000));
    };
  }
  on(h: WSHandler) { this.handlers.add(h); }
  send(msg: any) {
    if (this.ws?.readyState === 1) this.ws.send(JSON.stringify(msg));
  }
  close() { this.closed = true; this.ws?.close(); }
}
